:host {
  display: block;
  --push-color: var(--sl-push-color, #202121);
  --win-color: var(--sl-win-color, #04802d);
  --loss-color: var(--sl-loss-color, #cc0e00);
}

.sportsline-chip {
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
}

.sportsline-chip--win {
  color: var(--win-color);
  border: 1px solid var(--win-color);
}

.sportsline-chip--loss {
  color: var(--loss-color);
  border: 1px solid var(--loss-color);
}

.sportsline-chip--push {
  color: var(--push-color);
  border: 1px solid var(--push-color);
}

.sportsline-chip--push::after {
  content: 'PUSH';
}

.sportsline-chip--win::after {
  content: 'WIN';
}

.sportsline-chip--loss::after {
  content: 'LOSS';
}
